/*
 * Favorites (wishlist) toggle.
 *
 * Reads state that layout/theme.liquid rendered into window.HD_FAVORITES:
 *   { loggedIn, customerId, loginUrl, endpoint }
 *
 * Heart INITIAL state is rendered server-side by snippets/favorite-button.liquid,
 * so this file only handles the click:
 *   - guest  -> redirect to login (favorites live on the account)
 *   - logged in -> optimistic flip + POST to the Stocker backend; on any failure
 *     it reverts the heart and never throws, so a backend blip can't break the page.
 * Matches the theme's other backend calls (silent-fail, no hard dependency).
 */
(function () {
  "use strict";

  var cfg = window.HD_FAVORITES || {};
  var ENDPOINT = cfg.endpoint || "https://discounterstocker.hypnoticdog.co/favorites";

  function returnUrl() {
    return window.location.pathname + window.location.search;
  }

  function redirectToLogin() {
    var base = cfg.loginUrl || "/account/login";
    var sep = base.indexOf("?") === -1 ? "?" : "&";
    window.location.href = base + sep + "return_url=" + encodeURIComponent(returnUrl());
  }

  function setState(btn, favorited) {
    btn.classList.toggle("is-active", !!favorited);
    btn.setAttribute("aria-pressed", favorited ? "true" : "false");
    var label = favorited ? "Remove from favorites" : "Save to favorites";
    btn.setAttribute("aria-label", label);
    btn.setAttribute("title", label);

    // Optional adjacent text label (used on the PDP). Flip its copy to match.
    var wrap = btn.parentNode;
    var textEl = wrap && wrap.querySelector ? wrap.querySelector("[data-favorite-label]") : null;
    if (textEl) {
      var addTxt = textEl.getAttribute("data-label-add") || "Add to your favorites to view later";
      var savedTxt = textEl.getAttribute("data-label-saved") || "Saved to your favorites";
      textEl.textContent = favorited ? savedTxt : addTxt;
    }
  }

  // On the favorites page, dropping a favorite should remove its card.
  function maybeRemoveCard(btn) {
    var page = btn.closest ? btn.closest("[data-favorites-page]") : null;
    if (!page) return;
    var card = btn.closest("[data-favorite-card]") || btn.closest("[data-product-card]");
    if (card && card.parentNode) card.parentNode.removeChild(card);
  }

  function toggle(btn) {
    if (btn.getAttribute("data-favorite-busy") === "1") return;

    if (!cfg.loggedIn || !cfg.customerId) {
      redirectToLogin();
      return;
    }
    if (typeof fetch !== "function") return;

    var productId = btn.getAttribute("data-product-id");
    if (!productId) return;

    var wasActive = btn.classList.contains("is-active");
    var nextAction = wasActive ? "remove" : "add";

    btn.setAttribute("data-favorite-busy", "1");
    setState(btn, !wasActive); // optimistic

    fetch(ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        customer_id: cfg.customerId,
        product_id: productId,
        favorite_action: nextAction
      })
    })
      .then(function (res) {
        if (!res.ok) throw new Error("favorites_http_" + res.status);
        return res.json();
      })
      .then(function (data) {
        var favorited = data && typeof data.favorited === "boolean" ? data.favorited : !wasActive;
        setState(btn, favorited);
        if (!favorited) maybeRemoveCard(btn);
      })
      .catch(function () {
        setState(btn, wasActive); // revert; never break the page
      })
      .then(function () {
        btn.removeAttribute("data-favorite-busy");
      });
  }

  document.addEventListener("click", function (evt) {
    var target = evt.target;
    if (!target.closest) return;
    var btn = target.closest("[data-favorite-toggle]");
    // Clicking the adjacent text label (PDP) also toggles its heart — one tap target.
    if (!btn) {
      var lbl = target.closest("[data-favorite-label]");
      if (lbl && lbl.parentNode) btn = lbl.parentNode.querySelector("[data-favorite-toggle]");
    }
    if (!btn) return;
    evt.preventDefault();
    evt.stopPropagation();
    toggle(btn);
  });
})();
